import { cn, FileDropzoneOverlay, FileDropzoneWrapper } from "@qw/ui";
import type { ComponentProps, FC } from "react";

import { useChatForm } from "./use-chat-form";

interface ChatFormFileDropzoneProps extends Omit<ComponentProps<typeof FileDropzoneWrapper>, "dropzoneState"> {}

export const ChatFormFileDropzone: FC<ChatFormFileDropzoneProps> = ({ children, className, ...props }) => {
  const { dropzone } = useChatForm();

  return (
    <FileDropzoneWrapper dropzoneState={dropzone} className={cn("flex-1", className)} {...props}>
      {children}
      <FileDropzoneOverlay dropzoneState={dropzone} className="text-sm" />
    </FileDropzoneWrapper>
  );
};
